import initialState from '../initialstate';
import * as actions from '../../actions/actiontypes';

export default function helixReducer(state = initialState.helixProjects, action) {
	switch (action.type) {
		case actions.GET_PROJECTDETAIL_BY_PROJECTID_FROM_HELIX:
			return action.response || state;
		case actions.GET_HELIX_PROJECT:
			return action.response || state;
		case actions.CLEANUP_HELIX_PROJECT_STATE:
			return initialState.helixProjects;
		default:
			return state;
	}
}
